export default "__VITE_ASSET__BsQK9nO6__"